import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginScreen from './screens/LoginScreen';  // Componente de Login
import MainLayout from './screens/MainLayout';    // Layout com o menu lateral (Outlet como pai)
import AdminLayout from './screens/AdminLayout';  // Layout para rotas admin (Outlet como pai)
import HomeScreen from './screens/DashBoard';    // Componente do Dashboard
import MessageSchedule from './screens/MessageSchedule';
import LabelPage from './screens/LabelScreen';
import CRMPage from './screens/CRMPage';
import AccessPage from './screens/AccessPage';
import SectorsPage from './screens/SectorsPage';
import ProfilePage from './screens/ProfilePage';
import PrivacyPolicyPage from './screens/PrivacyPolicyPage';
import TermsOfUsePage from './screens/TermsOfUsePage';
import NotFoundPage from './screens/NotFoundPage';
import Chat from './screens/Chat';
import AIAssistantPage from './screens/AIAssistantPage';
import FinanceiroLayout from './screens/financeiro/FinanceiroLayout';
import {
  FinanceiroDashboardPage,
  FinanceiroLancamentosPage,
  FinanceiroCadastrosPage,
} from './screens/financeiro/FinanceiroPages';
// Admin Components
import PlatformAdminLayout from './screens/Platform/Layout/PlatformAdminLayout';
import AdminLoginScreen from './screens/Platform/Auth/AdminLoginScreen';
import AdminDashboard from './screens/Platform/Dashboard/AdminDashboard';
import AdminPlans from './screens/Platform/Plans/AdminPlans';
import AdminUsers from './screens/Platform/Users/AdminUsers';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginScreen />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/terms-of-use" element={<TermsOfUsePage />} />

      {/* Ligchat Financeiro: fora do MainLayout — tela própria, menu lateral próprio (path direto /financeiro) */}
      <Route path="/financeiro" element={<FinanceiroLayout />}>
        <Route index element={<Navigate to="/financeiro/inicio" replace />} />
        <Route path="inicio" element={<FinanceiroDashboardPage />} />
        <Route path="lancamentos" element={<FinanceiroLancamentosPage />} />
        <Route path="cadastros" element={<FinanceiroCadastrosPage />} />
      </Route>

      <Route element={<MainLayout />}>
        <Route path="/dashboard" element={<HomeScreen />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/labels" element={<LabelPage />} />
        <Route path="/crm" element={<CRMPage />} />
        <Route path="/schedule" element={<MessageSchedule />} />
        <Route element={<AdminLayout />}>
          <Route path="/access" element={<AccessPage />} />
          <Route path="/sectors" element={<SectorsPage />} />
        </Route>
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/ai-assistant" element={<AIAssistantPage />} />
      </Route>

      {/* Rotas do Painel Administrativo */}
      <Route path="/admin/login" element={<AdminLoginScreen />} />
      <Route path="/admin" element={<PlatformAdminLayout />}>
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="plans" element={<AdminPlans />} />
        <Route path="users" element={<AdminUsers />} />
      </Route>

      {/* Rota 404 para páginas não encontradas */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes; 